import { Nullable } from '@starsoft/common/interfaces';
import {
  UserRestrictionsStateProps,
  UserRestrictionsActions,
  SetUserRestrictionsPayload,
  UserRestrictionsStatePayload,
  SetUnreachableRestrictionPayload,
} from './props';
import { UserRestriction } from '@/models/user-restriction';
import { Restriction } from '@/models/restriction';

const initialState: UserRestrictionsStateProps = {
  userRestrictions: [],
  restriction: null,
};

export default function userRestrictionsReducer(
  state: UserRestrictionsStateProps = initialState,
  action: UserRestrictionsStatePayload,
): UserRestrictionsStateProps {
  switch (action.type) {
    case UserRestrictionsActions.Set:
      {
        const userRestriction: Nullable<UserRestriction> = (
          action as SetUserRestrictionsPayload
        ).payload;

        if (userRestriction === null) {
          return {
            ...state,
            userRestrictions: [],
          };
        }

        if (
          state.userRestrictions.find(
            restriction => restriction?.id === userRestriction?.id,
          )
        ) {
          return {
            ...state,
          };
        }

        return {
          ...state,
          userRestrictions: !!userRestriction
            ? state.userRestrictions.concat(userRestriction)
            : state.userRestrictions,
        };
      }
      break;
    case UserRestrictionsActions.SetUnreachableRestriction: {
      const restriction: Nullable<Restriction> = (
        action as SetUnreachableRestrictionPayload
      ).payload;

      if (restriction === null) {
        return {
          ...state,
          restriction: null,
        };
      }

      return {
        ...state,
        restriction,
      };
    }
    case UserRestrictionsActions.Unset:
      return {
        ...state,
        restriction: null,
        userRestrictions: [],
      };
    default:
      return state;
  }
}
